import ServiceRecordChangeEntry from '../ServiceRecordChangeEntry';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceRecordChangeLog: FunctionComponent<Props> = ({
    changes,
    className = '',
    testId = TEST_ID
}) => {
    // Newest-first like the history list — the latest edit reads first. Entries have
    // no id, and one save can stamp same-timestamp same-field entries (photo batches),
    // so the key needs the index to stay unique; the list is display-only and rebuilt
    // from the record on every change, so index keys are safe here.
    const sortedChanges = [...changes].sort(
        (first, second) =>
            new Date(second.changedAt).getTime() - new Date(first.changedAt).getTime()
    );

    return (
        <VerticalContainer
            className={`${styles.serviceRecordChangeLog} ${className}`}
            testId={testId}>
            {sortedChanges.map((change, index) => (
                <ServiceRecordChangeEntry
                    change={change}
                    key={`${change.changedAt}-${change.fieldChanged}-${index}`}
                />
            ))}
        </VerticalContainer>
    );
};

export default ServiceRecordChangeLog;
